import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from 'redux-persist';

import userReducer from './user-reducer/user.reducer';
import userRoleReducer from './userRole-reducer/userRole.reducer';
import syncFineReducer from './sync-fines-reducer/sync-fines.reducer';
import businessProfileReducer from './business-profile-reducer/business-profile-reducer';

const reducers = combineReducers({
  userReducer,
  userRoleReducer,
  syncFineReducer,
  businessProfileReducer,
});

export const store = configureStore({
  reducer: reducers,
  devTools: !import.meta.env.PROD,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = any> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
